"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9570],{

/***/ 31121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H1": function() { return /* binding */ H1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46052);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);






var H1 = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var styles = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("h1");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "h1",
        __css: styles
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 39570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductListHeader": function() { return /* reexport */ ProductListHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(92684);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/chakra-ui-transition.esm.js
var chakra_ui_transition_esm = __webpack_require__(37496);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/components/atoms/Text/H1.tsx
var H1 = __webpack_require__(31121);
// EXTERNAL MODULE: ./src/components/molecules/ProductListHeaderFilterBar/ProductListHeaderFilterBar.tsx + 2 modules
var ProductListHeaderFilterBar = __webpack_require__(31755);
// EXTERNAL MODULE: ./src/globalStyles/index.ts + 2 modules
var globalStyles = __webpack_require__(63319);
// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var constants = __webpack_require__(71467);
// EXTERNAL MODULE: ./src/utils/collections.tsx
var collections = __webpack_require__(34102);
// EXTERNAL MODULE: ./src/utils/filters.ts
var utils_filters = __webpack_require__(97126);
// EXTERNAL MODULE: ./src/utils/images.ts
var utils_images = __webpack_require__(57352);
// EXTERNAL MODULE: ./src/utils/ssr.ts + 1 modules
var ssr = __webpack_require__(11420);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/organisms/ProductListHeader/styles.ts
/* eslint-disable import/no-unresolved */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 800;\n  font-size: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-width: 160px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-width: 160px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  max-width: fit-content;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: fit-content;\n  min-width: 200px;\n  align-items: center;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n  flex-direction: row:\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ProductListHeaderText = emotion_styled_browser_esm/* default.p */.Z.p(_templateObject());
var ProductListHeaderContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), globalStyles/* minMedia.mediumScreen */.td.mediumScreen(_templateObject1()), globalStyles/* minMedia.smallScreen */.td.smallScreen(_templateObject2()));
var ProductLenderContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5(), globalStyles/* minMedia.smallScreen */.td.smallScreen(_templateObject4()));
var ProductLenderInnerContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());

;// CONCATENATED MODULE: ./src/components/organisms/ProductListHeader/ProductListHeader.tsx




// @ts-ignore unused import on React











var ProductListHeader = function(param) {
    var title = param.title, seoDescription = param.seoDescription, aboveProductsDescription = param.aboveProductsDescription, showFilters = param.showFilters, setShowFilters = param.setShowFilters, activeSortOption = param.activeSortOption, numberOfProducts = param.numberOfProducts, activeFilters = param.activeFilters, filters = param.filters, attributes = param.attributes, clearFilters = param.clearFilters, locationFilter = param.locationFilter, onLocationFilterChange = param.onLocationFilterChange, pricesFilter = param.pricesFilter, onPricesFilterChange = param.onPricesFilterChange, deliveryFilter = param.deliveryFilter, setDeliveryFilter = param.setDeliveryFilter, onOrder = param.onOrder, onAttributeFiltersChange = param.onAttributeFiltersChange, lenderInfo = param.lenderInfo, infiniteScrollingMode = param.infiniteScrollingMode, keyword = param.keyword, setKeyword = param.setKeyword, displayLoader = param.displayLoader, pageType = param.pageType, aboveProductContent = param.aboveProductContent;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(constants/* breakpoints.xl */.AV.xl, ")")), 1), isDesktop = ref2[0];
    var ordersMade = (lenderInfo === null || lenderInfo === void 0 ? void 0 : lenderInfo.lenderOrdersMade) || 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                backgroundColor: globalStyles/* defaultTheme.colors.white */.uH.colors.white,
                w: "full",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    maxWidth: "75rem",
                    marginX: "auto",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_transition_esm/* Collapse */.UO, {
                        in: !infiniteScrollingMode,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                            marginX: "auto",
                            maxWidth: "fit-content",
                            textAlign: "center",
                            children: [
                                (lenderInfo === null || lenderInfo === void 0 ? void 0 : (ref = lenderInfo.avatar) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                    src: (ref1 = lenderInfo.avatar) === null || ref1 === void 0 ? void 0 : ref1.url,
                                    alt: "".concat(lenderInfo.name, " Profile Image"),
                                    width: 80,
                                    height: 80,
                                    loader: utils_images/* imageLoader */.X,
                                    loading: "lazy",
                                    objectFit: "contain"
                                }),
                                (pageType === null || pageType === void 0 ? void 0 : pageType.slug) === ssr/* PageTypes.DESIGNER */.c7.DESIGNER ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "article-page__header",
                                    style: {
                                        marginBottom: "18px"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                        children: title
                                    })
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H1.H1, {
                                    mt: 0,
                                    fontSize: "3xl",
                                    children: title
                                }),
                                lenderInfo && !infiniteScrollingMode && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    margin: "0 auto",
                                    maxWidth: "fit-content",
                                    minWidth: "200px",
                                    paddingTop: "1.5rem",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "1rem",
                                    fontSize: 18,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductLenderContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Rating, {
                                                // @ts-ignore
                                                size: 32,
                                                // scale={5}
                                                rate: lenderInfo.rating,
                                                fillColor: "#000",
                                                showText: true
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductLenderInnerContainer, {
                                                children: [
                                                    ordersMade >= 3 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductListHeaderContainer, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListHeaderText, {
                                                                children: lenderInfo.lenderOrdersMade
                                                            }),
                                                            ordersMade === 1 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                                children: "Order"
                                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                                children: "Orders"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProductListHeaderContainer, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListHeaderText, {
                                                                children: numberOfProducts
                                                            }),
                                                            numberOfProducts === 1 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                                children: "Item to Rent"
                                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                                children: "Items to Rent"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Center */.M5, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                        maxWidth: "1024px",
                                        children: [
                                            aboveProductContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.RichTextEditorContent, {
                                                jsonData: aboveProductContent,
                                                sanitizationNotRequired: true
                                            }),
                                            seoDescription && !aboveProductContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: seoDescription
                                            }),
                                            aboveProductsDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: aboveProductsDescription
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListHeaderFilterBar/* ProductListHeaderFilterBar */.t, {
                activeSortOption: activeSortOption,
                openFiltersMenu: function() {
                    return setShowFilters(true);
                },
                numberOfProducts: numberOfProducts,
                activeFilters: activeFilters,
                activeFiltersAttributes: (0,utils_filters/* getActiveFilterAttributes */.At)(filters === null || filters === void 0 ? void 0 : filters.attributes, attributes) || [],
                clearFilters: clearFilters,
                pricesFilter: pricesFilter,
                onPricesFilterChange: onPricesFilterChange,
                locationFilter: locationFilter,
                onLocationFilterChange: onLocationFilterChange,
                sortOptions: collections/* SORT_OPTIONS */.a,
                onChange: onOrder,
                onCloseFilterAttribute: onAttributeFiltersChange,
                mobile: !isDesktop,
                showFilters: showFilters,
                lenderView: !!lenderInfo,
                deliveryFilter: deliveryFilter,
                setDeliveryFilter: setDeliveryFilter,
                title: infiniteScrollingMode ? title : "",
                lenderRating: filters === null || filters === void 0 ? void 0 : filters.lenderRating,
                keyword: keyword,
                setKeyword: setKeyword,
                displayLoader: displayLoader
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ProductListHeader/index.ts



/***/ }),

/***/ 34102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ FilterQuerySet; },
/* harmony export */   "a": function() { return /* binding */ SORT_OPTIONS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47355);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _temp_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72110);





var SORT_OPTIONS = [
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsClear */ .hA.sortOptionsClear)),
        value: null
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsPrice */ .hA.sortOptionsPrice)),
        value: "price"
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsPriceDsc */ .hA.sortOptionsPriceDsc)),
        value: "-price"
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsCreatedAt */ .hA.sortOptionsCreatedAt)),
        value: "created_at"
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsCreatedAtDsc */ .hA.sortOptionsCreatedAtDsc)),
        value: "-created_at"
    }, 
];
var FilterQuerySet = {
    encode: function encode(valueObj) {
        var str = [];
        Object.keys(valueObj).forEach(function(value) {
            str.push("".concat(value, "_").concat(valueObj[value].join("_")));
        });
        return str.join(".");
    },
    decode: function decode(strValue) {
        var obj = {};
        var propsWithValues = (strValue || "").split(".").filter(function(n) {
            return n;
        });
        propsWithValues.map(function(value) {
            var propWithValues = value.split("_").filter(function(n) {
                return n;
            });
            obj[propWithValues[0]] = propWithValues.slice(1);
        });
        return obj;
    }
};


/***/ }),

/***/ 59686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ priceFilterOptions; },
/* harmony export */   "Ob": function() { return /* binding */ locationFilterOptions; },
/* harmony export */   "j_": function() { return /* binding */ priceFilterValues; },
/* harmony export */   "qV": function() { return /* binding */ locationFilterValues; }
/* harmony export */ });
var priceFilterOptions = [
    {
        name: "Under $100",
        slug: "under-100"
    },
    {
        name: "$100 - $150",
        slug: "100-150"
    },
    {
        name: "$150 - $200",
        slug: "150-200"
    },
    {
        name: "$200 - $250",
        slug: "200-250"
    },
    {
        name: "Over $250",
        slug: "over-250"
    }, 
];
var priceFilterValues = {
    "under-100": {
        gte: 0,
        lte: 99.99,
        slug: "under-100"
    },
    "100-150": {
        gte: 100,
        lte: 150,
        slug: "100-150"
    },
    "150-200": {
        gte: 150,
        lte: 200,
        slug: "150-200"
    },
    "200-250": {
        gte: 200,
        lte: 250,
        slug: "200-250"
    },
    "over-250": {
        gte: 250.99,
        lte: null,
        slug: "over-250"
    }
};
var locationFilterValues = {
    adelaide: {
        gte: 5000,
        lte: 5799,
        slug: "adelaide",
        name: "Adelaide"
    },
    brisbane: {
        gte: 4000,
        lte: 4999,
        slug: "brisbane",
        name: "Brisbane"
    },
    canberra: {
        gte: 2600,
        lte: 2618,
        slug: "canberra",
        name: "Canberra"
    },
    darwin: {
        gte: 800,
        lte: 899,
        slug: "darwin",
        name: "Darwin"
    },
    hobart: {
        gte: 7000,
        lte: 7789,
        slug: "hobart",
        name: "Hobart"
    },
    melbourne: {
        gte: 3000,
        lte: 3999,
        slug: "melbourne",
        name: "Melbourne"
    },
    perth: {
        gte: 6000,
        lte: 6797,
        slug: "perth",
        name: "Perth"
    },
    sydney: {
        gte: 2000,
        lte: 2599,
        slug: "sydney",
        name: "Sydney"
    }
};
var locationFilterOptions = Object.keys(locationFilterValues).map(function(key) {
    return {
        name: locationFilterValues[key].name,
        slug: locationFilterValues[key].slug,
        lte: locationFilterValues[key].lte,
        gte: locationFilterValues[key].gte
    };
});


/***/ }),

/***/ 97126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ getActiveFilterAttributes; },
/* harmony export */   "Xk": function() { return /* binding */ getLocationFilter; },
/* harmony export */   "YA": function() { return /* binding */ getBrowserPath; },
/* harmony export */   "Zj": function() { return /* binding */ getFilters; },
/* harmony export */   "od": function() { return /* binding */ getDeliveryFilter; },
/* harmony export */   "pq": function() { return /* binding */ filtersChangeHandler; },
/* harmony export */   "ze": function() { return /* binding */ getPricesFilter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _filterData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59686);






/*
 * Functions used for initial state
 */ var getBrowserParams = function() {
    return new URLSearchParams(window.location.search).toString();
};
var getBrowserPath = function(router) {
    return [
        router.asPath.split("?")[0],
        getBrowserParams()
    ].join("?");
};
var getAttributesFromQueryParams = function(queryParams) {
    var prices = queryParams.prices, location = queryParams.location, lenderRating = queryParams.lenderRating, postCode = queryParams["post-code"], date = queryParams.date, attributes = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(queryParams, [
        "prices",
        "location",
        "lenderRating",
        "post-code",
        "date"
    ]);
    return attributes;
};
var getFilters = function(pageSize, pricesFilter, locationFilter, queryParams, sort, deliveryFilter, keyword) {
    return {
        attributes: getAttributesFromQueryParams(queryParams),
        pageSize: pageSize,
        lenderRating: queryParams === null || queryParams === void 0 ? void 0 : queryParams.lenderRating,
        prices: pricesFilter,
        postcodes: locationFilter.map(function(lf) {
            return {
                gte: lf.gte,
                lte: lf.lte
            };
        }),
        sortBy: sort || null,
        availableDeliveryDate: (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.date) || undefined,
        availableDeliveryPostcode: (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.postCode) || undefined,
        search: keyword || undefined
    };
};
var getPricesFilter = function(queryParams) {
    var prices = ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.prices) || []).filter(function(slug) {
        return slug in _filterData__WEBPACK_IMPORTED_MODULE_0__/* .priceFilterValues */ .j_;
    }).map(function(slug) {
        return _filterData__WEBPACK_IMPORTED_MODULE_0__/* .priceFilterValues */ .j_[slug];
    });
    return prices || [];
};
var getLocationFilter = function(queryParams) {
    return ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.location) || []).map(function(location) {
        var ref, ref1, ref2;
        return {
            gte: (ref = _filterData__WEBPACK_IMPORTED_MODULE_0__/* .locationFilterValues */ .qV[location]) === null || ref === void 0 ? void 0 : ref.gte,
            lte: (ref1 = _filterData__WEBPACK_IMPORTED_MODULE_0__/* .locationFilterValues */ .qV[location]) === null || ref1 === void 0 ? void 0 : ref1.lte,
            slug: location,
            name: (ref2 = _filterData__WEBPACK_IMPORTED_MODULE_0__/* .locationFilterValues */ .qV[location]) === null || ref2 === void 0 ? void 0 : ref2.name
        };
    });
};
var getDeliveryFilter = function(queryParams) {
    var ref, ref1;
    return {
        postCode: (queryParams === null || queryParams === void 0 ? void 0 : (ref = queryParams["post-code"]) === null || ref === void 0 ? void 0 : ref[0]) || "",
        date: (queryParams === null || queryParams === void 0 ? void 0 : (ref1 = queryParams.date) === null || ref1 === void 0 ? void 0 : ref1[0]) || ""
    };
};
/*
 * Change handlers
 */ var filtersChangeHandler = function(filters, attributeFilters, setAttributeFilters) {
    return function(name, value, singleValue) {
        if (attributeFilters && attributeFilters.hasOwnProperty(name)) {
            if (attributeFilters[name].includes(value)) {
                if (filters.attributes[name].length === 1) {
                    var att = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters);
                    delete att[name];
                    setAttributeFilters((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, att));
                } else {
                    setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, attributeFilters[name].filter(function(item) {
                        return item !== value;
                    }))));
                }
            } else if (singleValue && filters.attributes[name].length >= 1) {
                setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, [
                    value
                ])));
            } else {
                setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(attributeFilters[name]).concat([
                    value
                ]))));
            }
        } else {
            setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, [
                value
            ])));
        }
    };
};
var getActiveFilterAttributes = function(filterAttributes, attributes) {
    var getAttribute = function(attributeSlug, valueSlug) {
        var ref, ref1, ref2;
        var valueName = (ref2 = (ref = attributes === null || attributes === void 0 ? void 0 : attributes.find(function(param) {
            var slug = param.slug;
            return attributeSlug === slug;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1.find(function(param) {
            var slug = param.slug;
            return valueSlug === slug;
        })) === null || ref2 === void 0 ? void 0 : ref2.name;
        return valueName ? {
            attributeSlug: attributeSlug,
            valueName: valueName,
            valueSlug: valueSlug
        } : undefined;
    };
    return filterAttributes && Object.keys(filterAttributes).reduce(function(acc, key) {
        return acc.concat(filterAttributes[key].map(function(valueSlug) {
            return getAttribute(key, valueSlug);
        }));
    }, []).filter(Boolean);
};


/***/ })

}]);